import { installProfileHistory } from '~/utils/profileHistory'

export default function ({ app }) {
  installProfileHistory(app.router)
}
